import PropTypes from 'prop-types';
import Icon from '@/components/common/iconedLinks/Icon';
import MillesimaLink from '@/components/common/MillesimaLink';
import { URLS } from '@/constants/urls';
import { useAppSelector } from '@/redux';
import styles from './LevelSection.module.scss';

export const LevelSection = ({ title, description, levels, userLevel, asterixContent, labelBtnCGU, urlBtnCGU }) => {
	const loggedUser = useAppSelector(({ auth }) => auth.loggedUser);

	const getLevelClassName = (level) =>
		[styles.level, loggedUser && (!userLevel || userLevel.level !== level.level) && styles['level-locked']]
			.filter(Boolean)
			.join(' ');

	return (
		<>
			<div className={styles['section-head']}>
				<div className={styles['section-title']} data-test-id="section-title">
					{title.toUpperCase()}
				</div>
				<div
					dangerouslySetInnerHTML={{ __html: description }}
					className={styles['section-description']}
					data-test-id="section-description"
				/>
				<span className={styles['vertical-separator']}></span>
			</div>

			<div className={styles.levels}>
				{levels.map(
					(level) =>
						!level.isPrivate && (
							<div key={level.title} className={getLevelClassName(level)} data-test-id="level">
								<div className={styles['level-head']}>
									<span className={styles['level-title']}>{level.title.toUpperCase()}</span>
									<div className={styles['level-description']} style={{ backgroundColor: level.color }}>
										{!loggedUser || userLevel?.level >= level.level ? (
											<Icon src={URLS.LOCK_PREMIUM_OPEN} alt="lock-open" width={18} height={18} />
										) : (
											<Icon src={URLS.LOCK_PREMIUM} alt="lock" width={18} height={18} />
										)}
										<span>{level.description}</span>
									</div>
								</div>

								<div dangerouslySetInnerHTML={{ __html: level.espot }} />
							</div>
						),
				)}
			</div>

			{asterixContent && <div className={styles['asterix-content']} dangerouslySetInnerHTML={{ __html: asterixContent }} />}

			<div className={styles['container-btn-cgu']}>
				<MillesimaLink
					id="cgu"
					innerHtml={labelBtnCGU}
					href={urlBtnCGU}
					isTargetBlank
					isNofollow
					customClassName={{ container: styles.link }}
				/>
			</div>
		</>
	);
};

LevelSection.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	levels: PropTypes.array.isRequired,
	userLevel: PropTypes.object,
	asterixContent: PropTypes.string,
	labelBtnCGU: PropTypes.string.isRequired,
	urlBtnCGU: PropTypes.string.isRequired,
};

export default LevelSection;
